import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';

const Tasks = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          My Tasks
        </Typography>
        
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="body1" color="text.secondary">
            Tasks functionality coming soon...
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Tasks;